// extracted by mini-css-extract-plugin
module.exports = {"container":"OrganizeBackup_container__2Vs8Z","schema":"OrganizeBackup_schema__34eRk","text":"OrganizeBackup_text__-KWya","textItalic":"OrganizeBackup_textItalic__XpzA1"};